import React, { useEffect, useState, useCallback } from "react";
import { useGlobalContext } from "../../Context/GlobalContext";
import SunburstChart from "../../CHARTS/SunburstChart";
import { formatDateToDis } from "../../Utilitie";

const LostTrain = () => {
  const { globalDate } = useGlobalContext();
  const [lostTrainData, setLostTrainData] = useState(null);
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  function colorGenerator(baseKey, level) {
    const baseColors = {
      ELECTRICAL: "#66ccff",
      // //////////////
      ENGINEERING: "#9D65D1",
      // ////////////////
      UNUSUAL: "#f39c12",
      // ///////////////////
      OTHER: "#e74c3c",
      /////////////////////////
      BLOCKS: "#F6FA2B",
      ///////////////////////////
      "SIGN AND TELE": "#16EE69",
      ////////////////////
      "LAW AND ORDER": "#7F79DB",
      ///////////////////
      MECHANICAL: "#ffcc00",
      // COAL: "#3498db",
    };

    const shadeAdjust = ["", "B3", "99", "66", "33"]; // alpha transparency for demo
    const base = baseColors[baseKey] || "#888888";
    return base + (shadeAdjust[level] || "");
  }
  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(false);
    const url = `${process.env.REACT_APP_URL_PREFIX}pplostdata/date?date=${globalDate}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.token}`,

          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      setLostTrainData(data.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [globalDate]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const generateColor = () => {
    // Generates a random hex color code
    return `#${Math.floor(Math.random() * 16777215).toString(16)}`;
  };
  const generateBaseColor = () => {
    // Generates a base vibrant color
    const r = Math.floor(Math.random() * 156) + 100; // 100-255
    const g = Math.floor(Math.random() * 156) + 100;
    const b = Math.floor(Math.random() * 156) + 100;
    return { r, g, b };
  };

  const shadeColor = (baseColor, factor) => {
    // Darkens the base color by a factor, but keeps it readable
    const minBrightness = 80; // Prevents colors from getting too dark
    const r = Math.max(minBrightness, Math.floor(baseColor.r * (1 - factor)));
    const g = Math.max(minBrightness, Math.floor(baseColor.g * (1 - factor)));
    const b = Math.max(minBrightness, Math.floor(baseColor.b * (1 - factor)));
    return `rgb(${r}, ${g}, ${b})`;
  };

  const transformData = (data) => {
    if (!data || !Array.isArray(data)) return [];

    const groupMap = new Map();

    data.forEach(
      ({ Detention_Group, DET_CODE, SUB_CODE, TRAIN_NO, REMARKS }) => {
        if (!groupMap.has(Detention_Group)) {
          groupMap.set(Detention_Group, new Map());
        }
        const detCodeMap = groupMap.get(Detention_Group);

        if (!detCodeMap.has(DET_CODE)) {
          detCodeMap.set(DET_CODE, new Map());
        }
        const subCodeMap = detCodeMap.get(DET_CODE);

        if (!subCodeMap.has(SUB_CODE)) {
          subCodeMap.set(SUB_CODE, []);
        }
        subCodeMap.get(SUB_CODE).push({
          name: String(TRAIN_NO),
          value: 1, // Value still exists in case it's needed for calculations
          text: REMARKS, // Added REMARKS here so it appears on hover
        });
      },
    );

    return Array.from(groupMap.entries()).map(([group, detCodes]) => {
      const groupColor = colorGenerator(group, 0);
      return {
        name: group.replaceAll(" ", "\n"),
        itemStyle: {
          color: groupColor,
        },
        children: Array.from(detCodes.entries()).map(
          ([detCode, subCodes], detIndex) => {
            const detColor = colorGenerator(group, 1);

            return {
              name: detCode,
              itemStyle: {
                color: detColor,
              },
              children: Array.from(subCodes.entries()).map(
                ([subCode, trains], subIndex) => {
                  const subColor = colorGenerator(group, 2);

                  return {
                    name: subCode,
                    itemStyle: {
                      color: subColor,
                    },
                    children: trains.map((train, trainIndex) => ({
                      ...train,
                      itemStyle: {
                        color: colorGenerator(group, 3),
                      },
                    })),
                  };
                },
              ),
            };
          },
        ),
      };
    });
  };

  useEffect(() => {
    if (lostTrainData) {
      setChartData(transformData(lostTrainData));
    } else {
      setChartData([]);
    }
  }, [lostTrainData]);
  return (
    <div className="">
      <div>
        <h6>Lost Train Date: {formatDateToDis(globalDate)}</h6>
        <h6 className="bg-dark text-white m-1 p-1">LOST TRAIN</h6>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p style={{ color: "red" }}>Error fetching data. Please try again.</p>
      ) : chartData.length > 0 ? (
        <div className="mt-2">
          <SunburstChart
            data={chartData}
            length={lostTrainData?.length}
            from={"lost trains"}
            chartHeight={"350px"}
          />
        </div>
      ) : (
        <p>No data available.</p>
      )}
      {/* <CursorFollowBox className="position-absolute top-0 start-0" /> */}
    </div>
  );
};

export default LostTrain;
